import Crud from '../views/Vehicle/Crud'
import Entity from '../views/Vehicle/Add'

let routes = {
    path: '/vehicles',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/vehicles/add',
            name: 'NewVehicle',
            component: Entity,
            meta: {
                pageTitle: 'vehicle.crud.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'vehicle.form.newTitle',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/vehicles/edit/:id?',
            name: 'EditVehicle',
            component: Entity,
            meta: {
                pageTitle: 'vehicle.crud.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'vehicle.form.editTitle',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/vehicles',
            name: 'list-vehicles',
            component: Crud,
            meta: {
                pageTitle: 'vehicle.crud.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'vehicle.crud.title',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
